import axios from 'axios';

const SUBMIT_DOCUMENT_FIELD_MAPPER_API_URL = 'https://2g176ca6zl.execute-api.ap-southeast-1.amazonaws.com';

export const submitDocumentFieldMapper = async (payload) => {
  try {   

    const response = await axios.post(`${SUBMIT_DOCUMENT_FIELD_MAPPER_API_URL}/prod/documentFieldMapper`, payload);

    return response.data;
  } catch (error) {
    console.error("Error submitting job order and parameters:", {
      message: error.message,
      response: error.response ? error.response.data : 'No response',
      status: error.response ? error.response.status : 'No status',
    });
    throw error; // Re-throw the error for handling in the calling component
  }
};
